import { CheckoutCompletedQuoteConfirmation } from '../../models/checkout-completed-item/checkout-completed-quote-confirmation.interface';

export const mockCheckoutCompletedQuoteConfirmation: CheckoutCompletedQuoteConfirmation =
  {
    breakdownStartDate: '2022-03-05',
    bundlePlanNumbers: [],
    digitalId: undefined,
    planNumber: 'planNumber',
    renewalDate: '2022-03-05',
  };
